export default [
	{
		modulo: 9,
		privilegio: 62,
		routerName: 'admin-escolar-aluno',
		routerPath: '/admin-escolar-aluno',
		componentName: 'AdminEscolarAluno',
		componentPath: 'modules/layout/admin-escolar/aluno/main'
	},
	{
		modulo: 9,
		privilegio: 58,
		routerName: 'admin-escolar-curso',
		routerPath: '/admin-escolar-curso',
		componentName: 'AdminEscolarCurso',
		componentPath: 'modules/layout/admin-escolar/curso/main'
	},
	{
		modulo: 9,
		privilegio: 60,
		routerName: 'admin-escolar-disciplina',
		routerPath: '/admin-escolar-disciplina',
		componentName: 'AdminEscolarDisciplina',
		componentPath: 'modules/layout/admin-escolar/disciplina/main'
	},
	{
		modulo: 9,
		privilegio: 63,
		routerName: 'admin-escolar-matricula',
		routerPath: '/admin-escolar-matricula',
		componentName: 'AdminEscolarMatricula',
		componentPath: 'modules/layout/admin-escolar/matricula/main'
	},
	{
		modulo: 9,
		privilegio: 67,
		routerName: 'admin-escolar-pacote',
		routerPath: '/admin-escolar-pacote',
		componentName: 'AdminEscolarPacote',
		componentPath: 'modules/layout/admin-escolar/pacote-horas/main'
	},
	{
		modulo: 9,
		privilegio: 69,
		routerName: 'admin-escolar-regulamento',
		routerPath: '/admin-escolar-regulamento',
		componentName: 'AdminEscolarRegulamento',
		componentPath: 'modules/layout/admin-escolar/regulamento/main'
	},
	{
		modulo: 9,
		privilegio: 72,
		routerName: 'admin-escolar-gestao-ensino',
		routerPath: '/admin-gestao-ensino',
		componentName: 'adminEscolarGestaoEnsino',
		componentPath: 'modules/layout/admin-escolar/gestao-ensino/main'
	},
	{
		modulo: 9,
		privilegio: 72,
		routerName: 'admin-escolar-turma',
		routerPath: '/admin-escolar-turma',
		componentName: 'adminEscolarTurma',
		componentPath: 'modules/layout/admin-escolar/turma/main'
	},
	{
		modulo: 9,
		privilegio: 72,
		routerName: 'admin-escolar-aula',
		routerPath: '/admin-escolar-aula',
		componentName: 'adminEscolaraula',
		componentPath: 'modules/layout/admin-escolar/aula/main'
	},
	{
		modulo: 9,
		privilegio: 72,
		routerName: 'admin-escolar-frequencia',
		routerPath: '/admin-escolar-frequencia',
		componentName: 'adminEscolarfrequencia',
		componentPath: 'modules/layout/admin-escolar/frequencia/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-tipo-pagamento',
		routerPath: '/admin-escolar-tipo-pagamento',
		componentName: 'AdminEscolarTipoPagamento',
		componentPath: 'modules/layout/admin-escolar/pagamento/tipo-pagamento/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-detalhe-pagamento',
		routerPath: '/admin-escolar-detalhe-pagamento',
		componentName: 'AdminEscolarTipoDetalhePagamento',
		componentPath: 'modules/layout/admin-escolar/pagamento/detalhe/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-pagamento',
		routerPath: '/admin-escolar-pagamento',
		componentName: 'AdminEscolarPagamento',
		componentPath: 'modules/layout/admin-escolar/pagamento/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-ata-conclusao',
		routerPath: '/admin-escolar-ata-conclusao',
		componentName: 'AdminEscolarAtaConclusao',
		componentPath: 'modules/layout/admin-escolar/relatorios/ata-conclusao/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-ficha-avaliacao',
		routerPath: '/admin-escolar-ficha-avaliacao',
		componentName: 'AdminEscolarFichaAvaliacao',
		componentPath: 'modules/layout/admin-escolar/relatorios/ficha-avaliacao/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-ficha-avaliacao-teorica',
		routerPath: '/admin-escolar-ficha-avaliacao-teorica',
		componentName: 'AdminEscolarFichaAvaliacaoTeorica',
		componentPath: 'modules/layout/admin-escolar/relatorios/ficha-avaliacao-teorica/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-certificado',
		routerPath: '/admin-escolar-certificado',
		componentName: 'AdminEscolarCertificado',
		componentPath: 'modules/layout/admin-escolar/relatorios/certificado/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-lista-frequencia',
		routerPath: '/admin-escolar-lista-frequencia',
		componentName: 'AdminEscolarListaFrequencia',
		componentPath: 'modules/layout/admin-escolar/relatorios/lista-frequencia/main'
	}
]
